module.exports = __webpack_public_path__ + "img/xu2.eac5ce5a.png";